<template>
  <div style="position: fixed; left: 0; top: 0; width: 100%; height: 100%; z-index: 9999; display: flex; justify-content: center; align-items: center;"
       v-if="isBlurred">

    <div style="position:absolute; left: 0; top: 0; width: 100%; height: 100%; z-index: 9997;backdrop-filter: blur(8px) !important;
  background: rgba(0, 0, 0, 0.3) !important;"></div>

    <v-card class="elevation-12" style="max-width: 400px; width: 100%; z-index: 9998;">
      <v-card-title class="headline">
        {{ $t('general.proctoring.browser.dialog.title') }}
      </v-card-title>
      <v-card-text>
        {{ $t('general.proctoring.browser.dialog.message') }}
        <br>
        <br>
        {{ $t('general.proctoring.browser.dialog.time_remaining') }} <br><br>
        <div class="time-remaining">
          {{ totalAllowedSeconds - secondsBlurred }}
        </div>
      </v-card-text>
    </v-card>

  </div>
</template>

<script>
import soundController from "../../../../lib/soundController";
//import applicationEventHub from "../../../../events/applicationEventHub";
export default {
  name: "BrowserProctoringMonitor",
  props: {
    totalAllowedSeconds: {
      type: Number,
      default: 10
    }
  },
  data(){
    return {
      isBlurred: false,
      secondsBlurred: 0,
    }
  },
  mounted() {
    this.activate();
  },
  methods: {
    activate() {
      window.addEventListener('blur', this.onWindowBlur);
      window.addEventListener('focus', this.onWindowFocus);
    },
    deactivate() {
      window.removeEventListener('blur', this.onWindowBlur);
      window.removeEventListener('focus', this.onWindowFocus);
    },
    onWindowBlur() {
      this.isBlurred = true;
      this.secondsBlurred = 0;
      soundController.beep2();
      clearInterval(this._timeBlurredInterval);
      this._timeBlurredInterval = setInterval(() => {
        if (this.isBlurred) {
          this.secondsBlurred++;
          soundController.beep2();
          if (this.secondsBlurred >= this.totalAllowedSeconds) {
            this.emitIssue();
            clearInterval(this._timeBlurredInterval);
          }
        }else{
          this.onWindowFocus();
        }
      }, 1000);
    },
    onWindowFocus() {
      clearInterval(this._timeBlurredInterval);
      this.$nextTick(()=>{
        this.isBlurred = false;
        this.secondsBlurred = 0;
      });
    },
    emitIssue(){
      this.$emit('issue');
    }
  },
  beforeDestroy() {
    this.onWindowFocus();
    this.deactivate();
  }
}
</script>

<style scoped>
.time-remaining {
  font-size: 2.5rem;
  font-weight: bold;
  color: #980724;
  text-align: center;
  margin-top: 8px;
  margin-bottom: 8px;
  letter-spacing: 2px;
}
</style>